import { createSlice } from "@reduxjs/toolkit";

 const menuLoad = createSlice({
    name : 'menuLoad',
    initialState:{
        isOpen: false
    },
    reducers:{
        loadNav : (state) => {
            state.isOpen = true
        },
        closeNav : (state) => {
            state.isOpen = false
        }
    }
})

export const { loadNav, closeNav } = menuLoad.actions
export default menuLoad.reducer